module.exports = __webpack_public_path__ + "static/media/calendar.63247d09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/calendar.png
// module id = 607
// module chunks = 0